import { render, staticRenderFns } from "./DashboardClient.vue?vue&type=template&id=0b81b164&scoped=true&"
import script from "./DashboardClient.vue?vue&type=script&lang=js&"
export * from "./DashboardClient.vue?vue&type=script&lang=js&"
import style0 from "./DashboardClient.vue?vue&type=style&index=0&id=0b81b164&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b81b164",
  null
  
)

component.options.__file = "DashboardClient.vue"
export default component.exports